/* eslint-disable prettier/prettier */
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState, useLayoutEffect  } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/react";
import Button from "../../components/common/Button";
import CustomAutoComplete from "../../components/CustomAutoComplete";
import {
  MeetingTypes,
  RegionMeetingTypes,
  OtherMeetingTypes,
} from "../../contants";
import { SET_MEETING_TYPE } from "../../redux/reducers/attendance";
import Styles from "./styles";
import AutoCompleteDropdown from "../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import {
  getCurrentMonth,
  getCurrentYear,
  getFirstDateOfPreviousMonth,
} from "../../utils/dateAndTime";
import { selectAllSIUsers } from "../../redux/selectors/user";
import AttendanceForMobile from "./AttendanceForMobile";
import { selectAttendanceMeetingType } from "../../redux/selectors/attendance";
import Toast from "../../components/common/Toast";
import Attendances from "../../services/api/attendance";


function Attendance() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.auth?.userProfile?.data);

  const selectedMeetingType = useSelector(selectAttendanceMeetingType);

  const [meetinType, setMeetingType] = React.useState(null);
  const [otherMeetingType, setOtherMeetingType] = React.useState(null);

  const { isRegionSi } = useSelector(selectAllSIUsers);
  const [showToast, setShowToast] = useState(null);
  const HIDE_ACTION_BUTTONS = false;
  const ATTENDANCE_MEETING_TYPE_KEY = "attendance_selected_meeting_type";

useLayoutEffect(() => {
  localStorage.removeItem(ATTENDANCE_MEETING_TYPE_KEY);

  dispatch({
    type: SET_MEETING_TYPE,
    payload: { type: "" },
  });

  setMeetingType(null);
  setOtherMeetingType(null);
}, [dispatch]);

  const onClickForward = async () => {
    try {
      const fromDate = moment(getFirstDateOfPreviousMonth()).format(
        "YYYY-MM-DD"
      );

      if (otherMeetingType?.value) {
        navigate("/attendance");
      }

      const { data } = await Attendances.getAttendance({
        meetingType: meetinType.value,
        from: fromDate,
      });

      console.log("API RESPONSE 👉", data);
      navigate("/attendance");
    } catch (error) {
      console.error("API ERROR 👉", error);
      setShowToast({
        severity: "error",
        message: "No data available for selected meeting",
      });
      Sentry.captureException(error);
    }
  };

const onSelectMeeting = (selectedValue) => {
  setMeetingType(selectedValue || null);
  setOtherMeetingType(null);

  if (selectedValue?.value) {
    localStorage.setItem(
      ATTENDANCE_MEETING_TYPE_KEY,
      selectedValue.value
    );
  } else {
    localStorage.removeItem(ATTENDANCE_MEETING_TYPE_KEY);
  }

  dispatch({
    type: SET_MEETING_TYPE,
    payload: { type: selectedValue?.value ?? "" },
  });
};

const onSelectOtherMeeting = (selectedValue) => {
  setOtherMeetingType(selectedValue || null);
  setMeetingType(null);

  if (selectedValue?.value) {
    localStorage.setItem(
      ATTENDANCE_MEETING_TYPE_KEY,
      selectedValue.value
    );
  } else {
    localStorage.removeItem(ATTENDANCE_MEETING_TYPE_KEY);
  }

  dispatch({
    type: SET_MEETING_TYPE,
    payload: { type: selectedValue?.value ?? "" },
  });
};

React.useEffect(() => {
  const meetingOptions = isRegionSi ? RegionMeetingTypes : MeetingTypes;

  const selectedMeeting =
    meetingOptions.find((o) => o.value === selectedMeetingType) || null;

  const selectedOtherMeeting =
    OtherMeetingTypes.find((o) => o.value === selectedMeetingType) || null;

  setMeetingType(selectedMeeting);
  setOtherMeetingType(selectedOtherMeeting);
}, [selectedMeetingType, isRegionSi]);

  const isDistrictSI = Boolean(userProfile && userProfile.districtSi);
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <>
      {isMobile ? (
        <AttendanceForMobile />
      ) : (
        <Box>
          {/* Organization Structure - Horizontal */}
          <Box sx={{ mb: "16px" }}>
            <Typography style={{ ...Styles.typography, marginBottom: "8px" }}>
              Organization Structure
            </Typography>
            <Box
              sx={{
                border: "1px solid #C4C4C4",
                borderRadius: "8px",
                padding: "16px",
              }}
            >
              <Grid container spacing={2}>
                <Grid item md={2.4} xs={12}>
                  <CustomAutoComplete
                    required
                    name="Area"
                    label="Area"
                    disabled
                    options={[]}
                    optionLabelId="name"
                    optionValueId="structureId"
                    selectedValue={() => {}}
                    valueOnDisabled={userProfile?.areaName}
                  />
                </Grid>
                <Grid item md={2.4} xs={12}>
                  <CustomAutoComplete
                    required
                    name="Cluster"
                    label="Cluster"
                    disabled
                    options={[]}
                    optionLabelId="name"
                    optionValueId="structureId"
                    selectedValue={() => {}}
                    valueOnDisabled={userProfile?.clusterName}
                  />
                </Grid>

                <Grid item md={2.4} xs={12}>
                  <CustomAutoComplete
                    required
                    name="Zone"
                    label="Zone"
                    disabled
                    options={[]}
                    optionLabelId="name"
                    optionValueId="structureId"
                    selectedValue={() => {}}
                    valueOnDisabled={userProfile?.zoneName}
                  />
                </Grid>
                <Grid item md={2.4} xs={12}>
                  <CustomAutoComplete
                    required
                    name="Region"
                    label="Region"
                    disabled
                    options={[]}
                    optionLabelId="name"
                    optionValueId="structureId"
                    selectedValue={() => {}}
                    valueOnDisabled={userProfile?.regionName}
                  />
                </Grid>
                {!isRegionSi && (
                  <>
                    <Grid item md={2.4} xs={12}>
                      <CustomAutoComplete
                        required
                        name="Chapter"
                        label="Chapter"
                        disabled
                        options={[]}
                        optionLabelId="name"
                        optionValueId="structureId"
                        selectedValue={() => {}}
                        valueOnDisabled={userProfile?.chapterName}
                      />
                    </Grid>
                    <Grid item md={2.4} xs={12}>
                      <CustomAutoComplete
                        required
                        name="District"
                        label="District"
                        disabled
                        options={[]}
                        optionLabelId="name"
                        optionValueId="structureId"
                        selectedValue={() => {}}
                        valueOnDisabled={userProfile?.districtName}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>
          </Box>

          {/* Meetings Card */}
          <Box
            sx={{
              border: "1px solid #E0E0E0",
              borderRadius: "8px",
              padding: "20px",
            }}
          >
            {/* Month/Year Card */}
            <Box
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: "6px",
                padding: "12px 20px",
                mb: "20px",
                display: "flex",
                gap: "40px",
                width: "fit-content",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "11px",
                    color: "#8F92A1",
                    mb: "4px",
                  }}
                >
                  Month
                </Typography>
                <Typography
                  sx={{ fontWeight: "500", fontSize: "15px", color: "#171717" }}
                >
                  {getCurrentMonth()}
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "11px",
                    color: "#8F92A1",
                    mb: "4px",
                  }}
                >
                  Year
                </Typography>
                <Typography
                  sx={{ fontWeight: "500", fontSize: "15px", color: "#171717" }}
                >
                  {getCurrentYear()}
                </Typography>
              </Box>
            </Box>

            <Grid container spacing={2}>
              {/* Card 1: Mark Attendance */}
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    border: "1px solid #E0E0E0",
                    borderRadius: "8px",
                    padding: "16px",
                    height: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "15px",
                      color: "#171717",
                      mb: "16px",
                    }}
                  >
                    Mark Attendance
                  </Typography>

                  <Box sx={{ mb: "16px", position: "relative" }}>
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.displayName}
                      name="MeetingType"
                      label={
                        isRegionSi
                          ? "Select Meeting"
                          : "Select Discussion/Gosho"
                      }
                      options={isRegionSi ? RegionMeetingTypes : MeetingTypes}
                      onChange={onSelectMeeting}
                      value={meetinType}
                      style={{ fontSize: "14px" }}
                      disabled={!isDistrictSI && !isRegionSi}
             
                      filterOptions={(options) => options}
            
                      clearOnBlur={false}
                      inputProps={{
                        required: true,
                        placeholder: "Select meeting type",
                      }}
                    />


                    {meetinType && (isDistrictSI || isRegionSi) && (
                      <IconButton
                        size="small"
                        onClick={() => onSelectMeeting(null)}
                        sx={{
                          position: "absolute",
                          right: "55px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          zIndex: 1,
                          padding: "2px",
                          color: "#666",
                          "&:hover": {
                            color: "#333",
                            backgroundColor: "transparent",
                          },
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Box>

                  {!HIDE_ACTION_BUTTONS && (
                    <Button
                      variant="contained"
                      label="Mark Attendance"
                      onClick={onClickForward}
                      disabled={!meetinType?.value}
                      style={
                        !meetinType?.value
                          ? {
                              opacity: ".5",
                              width: "100%",
                              pointerEvents: "none",
                            }
                          : { width: "100%" }
                      }
                    />
                  )}
                </Box>
              </Grid>

              {/* Card 2: Add New Friend via Other Meetings */}
              {!isRegionSi && (
                <Grid item md={6} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      padding: "16px",
                      height: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "15px",
                        color: "#171717",
                        mb: "16px",
                      }}
                    >
                      Add New Friend via Other Meetings
                    </Typography>

                    {/* ✅ FIX: position relative wrapper for clear button */}
                    <Box sx={{ mb: "16px", position: "relative" }}>
                      <AutoCompleteDropdown
                        getOptionLabel={(option) => option.displayName}
                        name="OtherMeetingType"
                        label="Select Meeting"
                        options={OtherMeetingTypes}
                        onChange={onSelectOtherMeeting}
                        value={otherMeetingType}
                        style={{ fontSize: "14px" }}
                        disabled={!isDistrictSI && !isRegionSi}

                        filterOptions={(options) => options}

                        clearOnBlur={false}
                        inputProps={{
                          required: true,
                          placeholder: "Select other meeting type",
                        }}
                      />

                      {otherMeetingType && (isDistrictSI || isRegionSi) && (
                        <IconButton
                          size="small"
                          onClick={() => onSelectOtherMeeting(null)}
                          sx={{
                            position: "absolute",
                            right: "55px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 1,
                            padding: "2px",
                            color: "#666",
                            "&:hover": {
                              color: "#333",
                              backgroundColor: "transparent",
                            },
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>

                    {!HIDE_ACTION_BUTTONS && (
                      <Button
                        variant="contained"
                        label="Add New Friend"
                        onClick={onClickForward}
                        disabled={!otherMeetingType?.value}
                        style={
                          !otherMeetingType?.value
                            ? {
                                opacity: ".5",
                                width: "100%",
                                pointerEvents: "none",
                              }
                            : { width: "100%" }
                        }
                      />
                    )}
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
      )}

      {!!showToast && (
        <Toast
          open={!!showToast}
          severity={showToast?.severity}
          message={showToast?.message}
          handleClose={() => setShowToast(null)}
        />
      )}
    </>
  );
}

export default Attendance;
